import {InvoiceDao} from '../../dao';
import {ErrorModel} from '../../models';
import { UserState } from '../../reducers/UserReducer';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_INVOICE';

export async function createInvoice(
    userData: UserState["userProfileData"],
    invoice: Record<string, any>
) {
    try {
        const result = await InvoiceDao.createInvoice(userData?.userToken as string, invoice);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
